<template>
    <v-dialog v-model="d" width="40%" persistent>
        <v-card>
            <v-card-title>Manage Repeat</v-card-title>
            <v-card-text>
                <h6>Booking Name: {{active.originalBookingName}}</h6>
                <v-text-field required label="Description" v-model="active.description" />
                <v-select required label="Repeat Every" :items="periods" v-model="active.period" item-text="name" item-value="value" />
                <v-text-field required label="Repeat Frequency" type="number" v-model.number="active.frequency" />
<!--                <v-select label="Repeat On" :items="days" v-model="active.periodDay" item-text="name" item-value="value" />-->
              <div v-if="active.period !== 0">
                <p>Repeat On:</p>
                <v-radio-group v-model="active.periodDay" row>
                  <v-radio
                      v-for="r in days"
                      :key="r.value"
                      :label="r.name"
                      :value="r.value"
                  ></v-radio>
                </v-radio-group>
              </div>

              <p>Ends</p>
              <v-radio-group v-model="active.endsOnOccurrence">
                <v-radio
                    label="Never"
                    value="never"
                ></v-radio>
                <v-radio
                    label="On"
                    value="on"
                ></v-radio>
                <v-radio
                    label="After"
                    value="after"
                ></v-radio>
              </v-radio-group>

              <v-menu v-if="active.endsOnOccurrence === 'on'" ref="endMenu" v-model="endMenu" :close-on-content-click="false" :return-value.sync="active.endDate" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computedEndDateFormattedMomentjs" label="Enter End Date" readonly v-on="on" clearable />
                </template>
                <v-date-picker first-day-of-week="1" v-model="active.endDate" no-title scrollable>
                  <v-spacer />
                  <v-btn text color="primary" @click="endMenu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.endMenu.save(active.endDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field v-if="active.endsOnOccurrence === 'after'" label="Number of occurrences" type="number" v-model="active.occurrenceCount" />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="primary" @click="closeDialog">Cancel</v-btn>
              <v-btn v-if="active._id" :disabled="isLoading" :loading="isLoading" @click="launchWarning = true" color="success">Create New Booking</v-btn>
              <v-btn v-if="!active._id" :disabled="isLoading" :loading="isLoading" @click="createRepeat" color="success">Save Repeat</v-btn>
              <v-btn v-if="active._id" :disabled="isLoading" :loading="isLoading" @click="ignoreRepeat" class="ml-3" color="error">Ignore This Repeat</v-btn>
            </v-card-actions>
        </v-card>
      <v-dialog v-model="launchWarning" width="30%" persistent>
        <v-card>
          <v-card-title>Create Repeat Booking</v-card-title>
          <v-card-text>
            STOP! Please Check this booking needs to be activated, if not the regular reminder will be out of SYNC This will cost us unnecessary time!
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="launchWarning = false">Cancel</v-btn>
            <v-btn :loading="isLoading" :disabled="isLoading" color="info" @click="createBooking">Create Booking</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex';
    import {BookingsHttp} from "../../http/BookingsHttp";
    import {RepeatsHttp} from "../../http/RepeatsHttp";
    import moment from "moment";
    import EventBus from "@/EventBus";
    export default {
        name: "RepeatModal",
        data() {
            return {
                booking: null,
                periods: [
                    {name: 'Daily', value: 0},
                    {name: 'Weekly', value: 1},
                    {name: 'Monthly', value: 2},
                    {name: 'Annually', value: 3}
                ],
              days: [
                {name: 'Monday', value: 1},
                {name: 'Tuesday', value: 2},
                {name: 'Wednesday', value: 3},
                {name: 'Thursday', value: 4},
                {name: 'Friday', value: 5},
                {name: 'Saturday', value: 6},
                {name: 'Sunday', value: 0},
              ],
                isLoading: false,
                launchWarning: false,
              endMenu: false
            }
        },
        computed: {
            ...mapState("repeats", ["activeRepeat", "manageRepeatDialog"]),
          computedEndDateFormattedMomentjs () {
            return this.active.endDate ? moment(this.active.endDate).format('DD/MM/YYYY') : ''
          },
            d: {
                get() {
                    return this.manageRepeatDialog;
                }
            },
            active: {
                get() {
                    return this.activeRepeat;
                }
            }
        },
        methods: {
            ...mapActions("repeats", ["setActiveRepeat", "setManageRepeatDialog", "setRepeats", "setUpcomingRepeats"]),
            ...mapActions("bookings", ["setManageBookingDialog", "setActiveBooking"]),
            ...mapMutations("app", ["setToast"]),
            async closeDialog() {
                await this.setActiveRepeat({});
                await this.setManageRepeatDialog(false);
            },
            async ignoreRepeat() {
                this.active.nextDate = this.calculateNextDate(this.active.nextDate);
                this.active.isActioned = true;
                this.isLoading = true;
                try {
                    await RepeatsHttp.updateRepeat(this.active);
                    this.setToast({color: 'success', text: 'Repeat updated successfully', show: true});
                    EventBus.$emit("updateBookings");
                    await this.setActiveRepeat({});
                    await this.setManageRepeatDialog(false);
                    await this.setRepeats();
                    await this.setUpcomingRepeats();

                } catch(e) {
                    this.setToast({color: 'error', text: e.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            },
            async createRepeat() {
                this.active.nextDate = this.calculateNextDate(this.booking.startDate);
                this.active.isActioned = true;
                this.isLoading = true;
                try {
                    this.active._id ? await RepeatsHttp.updateRepeat(this.active) : await RepeatsHttp.createRepeat(this.active);
                    this.setToast({color: 'success', text: 'Repeat saved successfully', show: true});
                    await this.setActiveRepeat({});
                    await this.setManageRepeatDialog(false);
                    await this.setRepeats();
                    await this.setUpcomingRepeats();
                } catch(e) {
                    this.setToast({color: 'error', text: e.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            },
            async createBooking() {
                this.isLoading = true;
                try {
                    this.booking.startDate = this.active.nextDate;
                    const bookingEndDate = this.$moment(this.booking.endDate);
                    const endHour = bookingEndDate.hour();
                    const endMinute = bookingEndDate.minute();
                    const newEndDate = this.$moment(this.active.nextDate);
                    newEndDate.hour(endHour);
                    newEndDate.minute(endMinute);
                    this.booking.endDate = newEndDate.toDate();
                    this.booking.isApproved = false;
                    this.active.nextDate = this.calculateNextDate(this.active.nextDate);
                    this.active.isActioned = true;
                    this.active.lastBooked = new Date();
                    this.active.isRepeat = false;
                    if (this.active.endsOnOccurrence === 'after' && this.active.occurrenceCount > 1) {
                      this.active.occurrenceCount = this.active.occurrenceCount - 1;
                      await RepeatsHttp.updateRepeat(this.active);
                    }
                    if (this.active.endsOnOccurrence === 'after' && this.active.occurrenceCount === 0) {
                      // Delete the repeat
                      await RepeatsHttp.deleteRepeat(this.active._id);
                    }
                    if (this.active.endsOnOccurrence === 'on') {
                      const d1 = this.$moment(this.active.nextDate);
                      const d2 = this.$moment();
                      const diff = d1.diff(d2, 'days');
                      if (diff <= 0) {
                        // Delete the repeat
                        await RepeatsHttp.deleteRepeat(this.active._id);
                      }
                    }
                    delete this.booking._id;
                    delete this.booking.bookingMadeBy;
                    delete this.booking.xeroInvoiceNumber;
                    delete this.booking.xeroInvoiceLink;
                    delete this.booking.paymentRef;
                    this.booking.totalCharged = 0;
                    this.booking.isApproved = false;
                    EventBus.$emit("updateBookings");
                    await RepeatsHttp.updateRepeat(this.active);
                    await this.setActiveBooking(this.booking);
                    await this.setActiveRepeat({});
                    await this.setRepeats();
                    await this.setUpcomingRepeats();
                    await this.setManageRepeatDialog(false);
                    await this.setManageBookingDialog(true);

                } catch (e) {
                    this.setToast({color: 'error', text: e.response.data, show: true})
                } finally {
                    this.isLoading = false;
                }
            },
            calculateNextDate(date) {
              // eslint-disable-next-line no-console
              console.log(date);
              // eslint-disable-next-line no-console
              console.log(this.active.period);
              // eslint-disable-next-line no-console
              console.log(this.active.periodDay);
              // Period
              if (this.active.period && !this.active.periodDay) {

                switch (this.active.period){
                  case 0:
                    return this.$moment(date).add(this.active.frequency, 'days').toDate();
                  case 1:
                    return this.$moment(date).add(this.active.frequency, 'weeks').toDate();
                  case 2:
                    return this.$moment(date).add(this.active.frequency, 'months').toDate();
                  case 3:
                    return this.$moment(date).add(this.active.frequency, 'years').toDate();
                }
              } else {
                switch (this.active.period){
                  case 0:
                    return this.$moment(date).add(this.active.frequency, 'days').day(this.active.periodDay).toDate();
                  case 1:
                    return this.$moment(date).add(this.active.frequency, 'weeks').day(this.active.periodDay).toDate();
                  case 2:
                    return this.$moment(date).add(this.active.frequency, 'months').day(this.active.periodDay).toDate();
                  case 3:
                    return this.$moment(date).add(this.active.frequency, 'years').day(this.active.periodDay).toDate();
                }
              }
            }
        },
        watch: {
          manageRepeatDialog: {
                async handler(newVal) {

                    if (newVal && this.active.originalBookingId) {
                        this.booking = await BookingsHttp.getSingleBooking(this.active.originalBookingId).then(booking => booking.data);
                        if (!this.active.nextDate) {
                          this.active.nextDate = this.$moment(this.booking.startDate).toDate();
                        }
                      // eslint-disable-next-line no-console
                      console.log(this.active.nextDate);
                        this.booking.isApproved = false;
                      this.calculateNextDate(this.active.nextDate);
                    }
                },
                deep: true,
                immediate: true
            }
        }
    }
</script>

<style scoped>

</style>
